<h2 class="text-center" mat-dialog-title>{{'choosePassengersReport' | translate }}</h2>

<form [formGroup]="reportFormGroup" (ngSubmit)="generate()">
<mat-dialog-content fxLayout="column" class="p-4">
        <mat-form-field class="pt-2">
            <mat-label [style.fontSize]="'12px'">{{'report' | translate | titlecase}}</mat-label>
            <mat-select [style.fontSize]="'18px'" formControlName="report">
                <mat-option *ngFor="let report of reportOptions" [value]="report">
                    {{report | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="pt-2">
            <mat-label [style.fontSize]="'12px'">{{'fileType' | translate}}</mat-label>
            <mat-select [style.fontSize]="'18px'" formControlName="fileType">
                <mat-option *ngFor="let fileType of fileTypeOptions" [value]="fileType">
                    {{fileType}}
                </mat-option>
            </mat-select>
        </mat-form-field>

         <mat-form-field>
            <input matInput [ngxMatDatetimePicker]="startpicker" placeholder="{{ 'from' | translate }}" formControlName="startDate" [readonly]="true">
            <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #startpicker [hideTime]="true" [defaultTime]="defaultTime"></ngx-mat-datetime-picker>
        </mat-form-field>

        <mat-form-field>
            <input matInput [ngxMatDatetimePicker]="endpicker" placeholder="{{ 'to' | translate }}" formControlName="endDate" [readonly]="true">
            <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #endpicker [hideTime]="true" [defaultTime]="defaultTime"></ngx-mat-datetime-picker>
        </mat-form-field>
        <app-report-filename-editor #params [isSchedule]="false" (paramSelected)="fileName = $event"></app-report-filename-editor>

</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end" class="pt-4 pb-4">
    <button mat-raised-button mat-dialog-close color="sims">{{'close' | translate}}</button>
    <button mat-raised-button [disabled]="!isValid() || params.edit" class="ml-2"  type="submit" color="sims">{{'generate' | translate}}</button>
</mat-dialog-actions>
</form>
